module.exports = __webpack_public_path__ + "img/service3.e9303d01.png";